import React, { useState } from "react";
import * as styles from "./dropDownSmart.module.scss";
import arrowWhite from "../../../icons/arrows/downArrow.svg";
import arrowBlack from "../../../icons/arrows/downArrowBlack.svg";
import { Link } from "gatsby";
import DestacadosMobile from "../DestacadosMobile/DestacadosMobile";

const DropDownSmart = ({
  name = null,
  options,
  color,
  pattern,
  child,
  setIsOpened,
  isOpened,
}) => {
  const [isDropDownOpen, setDropDownOpen] = useState(false);
  const [isRotated, setRotated] = useState(false);
  const [openSubmenus, setOpenSubmenus] = useState({});

  const formatSubCategoryName = (name) => {
    return name.toLowerCase().replace(/\s+/g, "-");
  };

  const toggleDropdown = () => {
    setDropDownOpen(!isDropDownOpen);
    setRotated(!isRotated);
  };

  const toggleDropdown2 = (patternId) => {
    setOpenSubmenus((prevState) => {
      // Crear un nuevo estado donde todos los submenús están cerrados
      const resetState = Object.keys(prevState).reduce((acc, key) => {
        acc[key] = false;
        return acc;
      }, {});
  
      // Abrir solo el submenú correspondiente al `patternId`
      return {
        ...resetState,
        [patternId]: !prevState[patternId],
      };
    });
  };
  

  const colorStyles = {
    black: {
      backgroundColorVar: "var(--black-background)",
      textColorVar: "var(--black-text)",
      contentBackgroundVar: "var(--content-background-black)",
      contentTextVar: "var(--content-text-black)",
    },
    white: {
      backgroundColorVar: "var(--white-background)",
      textColorVar: "var(--white-text)",
      contentBackgroundVar: "var(--content-background-white)",
      contentTextVar: "var(--content-text-white)",
    },
  };

  const {
    backgroundColorVar,
    textColorVar,
    contentBackgroundVar,
    contentTextVar,
  } = colorStyles[color];

  const inlineStyles = {
    "--my-background-color-var": backgroundColorVar,
    "--my-text-color-var": textColorVar,
  };

  const contentStyles = {
    background: contentBackgroundVar,
    color: contentTextVar,
  };

  return (
    <>
      {options && name ? (
        <div>
          <div className={styles.container} onClick={toggleDropdown}>
            <button style={inlineStyles} className={styles.colorTexto}>
              {name}
            </button>
            {color === "black" ? (
              <div className={isRotated ? styles.rotate : styles.rotate2}>
                <img src={arrowWhite} alt="Icono" />
              </div>
            ) : (
              <div className={isRotated ? styles.rotate : styles.rotate2}>
                <img src={arrowBlack} alt="Icono" />
              </div>
            )}
          </div>

          {isDropDownOpen && (
            <div style={contentStyles}>
              {options?.map((option) =>
                option.link ? (
                  <Link to={option.link} key={option.id}>
                    <p className={styles.texto}>{option.name}</p>
                  </Link>
                ) : (
                  <p key={option.id} className={styles.texto}>
                    {option.name}
                  </p>
                )
              )}
            </div>
          )}
        </div>
      ) : null}

      {/*********** PADRE E HIJO ********************/}
      {pattern && child && name ? (
        <>
          <div className={styles.container} onClick={toggleDropdown}>
            <button style={inlineStyles} className={styles.colorTexto}>
              {name}
            </button>
            {color === "black" ? (
              <div className={isRotated ? styles.rotate : styles.rotate2}>
                <img src={arrowWhite} alt="Icono" />
              </div>
            ) : (
              <div className={isRotated ? styles.rotate : styles.rotate2}>
                <img src={arrowBlack} alt="Icono" />
              </div>
            )}
          </div>

          {isDropDownOpen && (
            <div
              className={`${styles.section__container} ${
                isDropDownOpen ? styles.open : ""
              }`}
            >
              {pattern?.map((pattern) => (
                <div
                  className={styles.title__container__children}
                  key={pattern.id}
                >
                  <div
                    className={styles.space__button}
                    onClick={() => toggleDropdown2(pattern.id)}
                  >
                    <button className={styles.colorTexto}>
                      {pattern.name}
                    </button>
                    <div
                      className={
                        openSubmenus[pattern.id]
                          ? styles.rotate3
                          : styles.rotate4
                      }
                    >
                      <img src={arrowBlack} alt="Icono" />
                    </div>
                  </div>

                  <div
                    className={`${styles.container__child} ${
                      openSubmenus[pattern.id] ? styles.open : ""
                    }`}
                  >
                    {child
                      .filter(
                        (subCategory) =>
                          subCategory.patternCategory === pattern.id
                      )
                      ?.map((subCategory) => (
                        <Link
                          to={`/productos/${formatSubCategoryName(
                            subCategory.name
                          )}/`}
                          key={subCategory.id}
                          className={styles.texto}
                          onClick={() => setIsOpened(!isOpened)}
                        >
                          {subCategory.name}
                        </Link>
                      ))}
                  </div>
                </div>
              ))}
              <DestacadosMobile />
            </div>
          )}
        </>
      ) : null}

      {!name && pattern && (
        <div className={styles.section__container}>
          {pattern?.map((patternItem) => (
            <div
              className={styles.title__container__children}
              key={patternItem.id}
              onClick={() => toggleDropdown2(patternItem.id)}
            >
              <div className={styles.space__button}>
                <button className={styles.colorTexto}>
                  {patternItem.name}
                </button>
                <div
                  className={
                    openSubmenus[patternItem.id]
                      ? styles.rotate3
                      : styles.rotate4
                  }
                >
                  <img src={arrowBlack} alt="Icono" />
                </div>
              </div>

              <div
                className={`${styles.container__child} ${
                  openSubmenus[patternItem.id] ? styles.open : ""
                }`}
              >
                {child
                  ?.filter(
                    (subCategory) =>
                      subCategory.patternCategory === patternItem.id
                  )
                  ?.map((subCategory) => (
                    <Link
                      to={`/productos/${formatSubCategoryName(
                        subCategory.name
                      )}/`}
                      key={subCategory.id}
                      className={styles.texto}
                    >
                      {subCategory.name}
                    </Link>
                  ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default DropDownSmart;
